// src/pages/Admin/CoursAgenda/components/CoursAgendaCourseCard.jsx

import React from "react";

import {
  FaClock,
  FaMapMarkerAlt,
  FaUser,
  FaUserFriends,
} from "react-icons/fa";

import { getPersonName } from "../utils/coursAgendaUtils";

const PeopleLine = ({
  people = [],
  icon: Icon,
  emptyText,
}) => {
  if (!people.length) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-400 dark:text-slate-500">
        <Icon className="shrink-0" />

        <span>{emptyText}</span>
      </div>
    );
  }

  const first = people[0];

  return (
    <div className="flex min-w-0 items-center gap-2 text-xs text-slate-600 dark:text-slate-300">
      <Icon className="shrink-0 text-slate-400" />

      <span className="truncate">
        {getPersonName(first)}

        {people.length > 1 && (
          <span className="ml-1 font-semibold">
            +{people.length - 1}
          </span>
        )}
      </span>
    </div>
  );
};

const CoursAgendaCourseCard = ({
  cours,
  onOpen,
}) => {
  const start =
    cours.heure_debut?.slice(0, 5) || "--:--";

  const end =
    cours.heure_fin?.slice(0, 5) || "--:--";

  const accentColor =
    cours.accentColor || "#64748b";

  return (
    <button
      type="button"
      onClick={() => onOpen?.(cours.id)}
      className="
        group
        relative
        w-full
        overflow-hidden
        rounded-2xl
        border border-slate-200
        bg-white
        p-4
        text-left
        shadow-sm
        transition
        hover:-translate-y-0.5
        hover:border-slate-300
        hover:shadow-md
        dark:border-slate-800
        dark:bg-slate-900
        dark:hover:border-slate-700
      "
      style={{
        borderLeftWidth: "5px",
        borderLeftColor: accentColor,
      }}
    >
      {/* Horaire */}
      <div className="mb-3 flex items-center justify-between gap-3">
        <div
          className="
            inline-flex items-center gap-2
            rounded-lg
            bg-slate-100
            px-2.5 py-1.5
            text-xs font-bold
            text-slate-800
            dark:bg-slate-800
            dark:text-slate-100
          "
        >
          <FaClock
            style={{
              color: accentColor,
            }}
          />

          {start} – {end}
        </div>

        <span
          className="h-2.5 w-2.5 shrink-0 rounded-full"
          style={{
            backgroundColor: accentColor,
          }}
        />
      </div>

      {/* Nom */}
      <h4 className="line-clamp-2 text-sm font-bold leading-snug text-slate-950 dark:text-white">
        {cours.nom_cours || "Cours"}
      </h4>

      {/* Thème */}
      {cours.theme_cours && (
        <p className="mt-1 line-clamp-2 text-xs font-medium text-slate-500 dark:text-slate-400">
          {cours.theme_cours}
        </p>
      )}

      {/* Infos */}
      <div className="mt-4 space-y-2 border-t border-slate-100 pt-3 dark:border-slate-800">
        <div className="flex min-w-0 items-center gap-2 text-xs text-slate-600 dark:text-slate-300">
          <FaMapMarkerAlt className="shrink-0 text-slate-400" />

          <span className="truncate">
            {cours.lieu ||
              "Lieu non renseigné"}
          </span>
        </div>

        <PeopleLine
          people={cours.enseignants}
          icon={FaUser}
          emptyText="Sans instructeur"
        />

        <PeopleLine
          people={cours.assistants}
          icon={FaUserFriends}
          emptyText="Sans assistant"
        />
      </div>
    </button>
  );
};

export default CoursAgendaCourseCard;